(function () {
  'use strict';

  if (window.NaxarlyServiceExtrasLoaded) return;
  window.NaxarlyServiceExtrasLoaded = true;

  function initReviews(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var rail = root.querySelector('[data-review-rail]');
    var cards = rail ? [...rail.querySelectorAll('[data-review-card]')] : [];
    var dots = [...root.querySelectorAll('[data-review-dots] button')];
    var previous = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    var activeIndex = 0;
    var scrollFrame = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function nearestCard() {
      if (!rail || !cards.length) return 0;
      return cards.reduce(function (nearest, card, index) {
        return Math.abs(card.offsetLeft - rail.scrollLeft) < Math.abs(cards[nearest].offsetLeft - rail.scrollLeft) ? index : nearest;
      }, 0);
    }

    function updateCarousel(index) {
      activeIndex = Math.max(0, Math.min(index, cards.length - 1));
      dots.forEach(function (dot, dotIndex) {
        if (dotIndex === activeIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === cards.length - 1;
    }

    function showCard(index) {
      if (!rail || !cards[index]) return;
      rail.scrollTo({ left: cards[index].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      updateCarousel(index);
    }

    if (rail && cards.length) {
      updateCarousel(0);
      rail.addEventListener('scroll', function () {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(function () { updateCarousel(nearestCard()); });
      }, { passive: true });
      rail.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        showCard(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      previous?.addEventListener('click', function () { showCard(activeIndex - 1); });
      next?.addEventListener('click', function () { showCard(activeIndex + 1); });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { showCard(index); });
      });
      window.addEventListener('resize', function () { updateCarousel(nearestCard()); });
    }

    var dialog = root.querySelector('[data-review-dialog]');
    var open = root.querySelector('[data-review-open]');
    var close = root.querySelector('[data-review-close]');
    var form = root.querySelector('[data-review-form]');
    var statuses = root.querySelectorAll('[data-review-status]');
    var status = statuses[statuses.length - 1];

    open?.addEventListener('click', function () {
      dialog?.showModal();
    });
    close?.addEventListener('click', function () {
      dialog?.close();
    });
    dialog?.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    form?.addEventListener('submit', async function (event) {
      event.preventDefault();
      var endpoint = root.dataset.submissionEndpoint;
      if (!endpoint) {
        if (status) status.textContent = 'Review submission is not available yet.';
        return;
      }

      var submit = form.querySelector('[type=submit]');
      submit.disabled = true;
      if (status) status.textContent = 'Submitting your review…';

      try {
        var body = new FormData(form);
        body.set('product_id', root.dataset.productId);
        body.set('service_handle', root.dataset.serviceHandle);
        body.set('review_token', new URLSearchParams(location.search).get('review_token') || body.get('review_token') || '');
        var response = await fetch(endpoint, { method: 'POST', body: body, headers: { Accept: 'application/json' } });
        var result = await response.json();
        if (!response.ok) throw new Error(result.message || 'Unable to submit your review.');
        form.reset();
        if (status) status.textContent = result.message || 'Thank you. Your review has been submitted for approval.';
        setTimeout(function () {
          dialog.close();
        }, 1800);
      } catch (error) {
        if (status) status.textContent = error.message || 'Unable to submit your review.';
      } finally {
        submit.disabled = false;
      }
    });
  }

  function initFaq(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var items = [...root.querySelectorAll('details')];
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initCta(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.querySelectorAll('[data-cta-action]').forEach(function (control) {
      control.addEventListener('click', function (event) {
        var action = control.dataset.ctaAction;
        if (action === 'open_slot') {
          event.preventDefault();
          window.Naxarly?.SlotSelector?.open();
        }
        if (action === 'scroll_packages') {
          event.preventDefault();
          document.querySelector('[data-nps]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (action === 'open_event') {
          event.preventDefault();
          document.querySelector('[data-neb] [data-details-toggle]')?.click();
        }
      });
    });
    var decision = document.querySelector('[data-nps]');
    var contact = root.querySelector('[data-cta-contact]');
    var call = root.querySelector('[data-cta-call]');
    var whatsapp = root.querySelector('[data-cta-whatsapp]');
    function updateContact(selection) {
      if (!contact || !decision) return;
      var callLink = decision.dataset.callLink || '';
      var whatsappLink = decision.dataset.whatsappLink || '';
      var title = selection?.title || 'this package';
      if (call) {
        call.hidden = !callLink;
        if (callLink) {
          call.href = callLink;
          call.setAttribute('aria-label', 'Call about ' + title);
        }
      }
      if (whatsapp) {
        whatsapp.hidden = !whatsappLink;
        if (whatsappLink) {
          try {
            var url = new URL(whatsappLink, window.location.origin);
            var availability = window.Naxarly?.Event?.getAvailability?.() || {};
            var lines = ['Hello, I have a question about a Naxarly package.', 'Service: ' + decision.dataset.serviceTitle, 'Package: ' + title];
            if (availability.date && availability.time && availability.city) lines.push('Event: ' + availability.date + ', ' + availability.time + ', ' + availability.city);
            url.searchParams.set('text', lines.join('\n'));
            whatsapp.href = url.toString();
          } catch (error) {
            whatsapp.href = whatsappLink;
          }
          whatsapp.setAttribute('aria-label', 'WhatsApp about ' + title);
        }
      }
      contact.hidden = !callLink && !whatsappLink;
    }
    window.Naxarly?.ServicePage?.subscribe(updateContact);
    updateContact(window.Naxarly?.ServicePage?.getSelection?.());
    window.addEventListener('naxarly:event:change', function () {
      updateContact(window.Naxarly?.ServicePage?.getSelection?.());
    });
  }

  function boot() {
    document.querySelectorAll('[data-naxarly-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-naxarly-faq]').forEach(initFaq);
    document.querySelectorAll('[data-naxarly-cta]').forEach(initCta);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
